import { useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { jwtDecode } from 'jwt-decode';
import ROUTE_PATH from '../constants/routes';

export const useAuthRedirect = () => {
    const { isAuthenticated } = useAuth();
    const navigate = useNavigate();
    const hasChecked = useRef(false);

    useEffect(() => {
        if (hasChecked.current) return;
        
        const checkAuth = () => {
            const accessToken = localStorage.getItem('accessToken');

            if (accessToken && isAuthenticated) {
                try {
                    const decoded = jwtDecode(accessToken);
                    if (decoded.exp && decoded.exp > Date.now() / 1000) {
                        navigate(ROUTE_PATH.DASHBOARD, { replace: true });
                    }
                } catch (error) {
                    localStorage.removeItem('accessToken');
                    localStorage.removeItem('refreshToken');
                }
            }
        };

        checkAuth();
        hasChecked.current = true;
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
};
